import { render, staticRenderFns } from "./ArticleInfoLinks.vue?vue&type=template&id=ebc3a51a&"
import script from "./ArticleInfoLinks.vue?vue&type=script&lang=js&"
export * from "./ArticleInfoLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports